<span class="sticker sticker--color-{{ color }}" [ngClass]="{ 'sticker--size-large': large }">
  <ng-content></ng-content>
</span>
